import "@/App.css";
import { Navigation } from "@/components/zoomy/Navigation";
import { Hero } from "@/components/zoomy/Hero";
import { Stats } from "@/components/zoomy/Stats";
import { FleetShowcase } from "@/components/zoomy/FleetShowcase";
import { PartnerSection } from "@/components/zoomy/PartnerSection";
import { ContactForm } from "@/components/zoomy/ContactForm";
import { Footer } from "@/components/zoomy/Footer";

function App() {
  return (
    <div className="App grain bg-[#050505] text-white min-h-screen">
      <Navigation />
      <main>
        <Hero />
        <Stats />
        <FleetShowcase />
        <PartnerSection />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
